export function sum(array) {
  if (!Array.isArray(array)) return 0;
  return array.reduce((sum, currentValue) => sum + currentValue, 0);
}

export function average(array) {
  if (!Array.isArray(array)) return 0;

  const lengthOfItems = array.length;
  const average = lengthOfItems ? sum(array) / lengthOfItems : 0;
  return average.toFixed(2);
}

export function averageNonZeros(array) {
  if (!Array.isArray(array)) return 0;

  const nonZeroArray = array.filter(item => item);
  const lengthOfItems = nonZeroArray.length;
  const average = lengthOfItems ? sum(nonZeroArray) / lengthOfItems : 0;
  return average.toFixed(2);
}
